import styled from "styled-components";
import theme from "@theme";

const BodyHeader = styled.div`
  padding: 15px 20px;
  background-color: #f7f9f7;
  border-bottom: 1px solid ${theme.colors.bordertask};
  position: fixed;
  width: 100%;
  z-index: 1000;
`;

const BodyContainer = styled.div`
  margin-top: 50px;
`;

const SC = {
  BodyHeader,
  BodyContainer,
};

export default SC;
